import React from 'react';
import { ImgWithPlaceholder } from '../../img-with-placeholder';
import { PlaceholdersLoaderGif } from '../../assets';
import { CheckCircleOutline } from '@mui/icons-material';

export function TemplateImage({ active = false, title, image }) {

    return (
        <div className={`position-relative card mb-2 rounded-4 shadow border border-5 p-1 ${active ? 'border-primary' : 'border-white'}`}>
            {active && <CheckCircleOutline className='position-absolute top-0 end-0 text-white me-n3 mt-n3 z-1 bg-primary rounded-5' sx={{ fontSize: 30 }} />}
            <ImgWithPlaceholder src={image} className="img-fluid pe-none" alt="..." unselectable='on' placeholder={PlaceholdersLoaderGif.loader_1080_1800} />
            <div className='text-center' loading="lazy">{title}</div>
        </div>
    );
}